<template>
  <div>
    <div class="navbar">
      <div class="item" @click="jumpCart">
        <img src="/images/common/cart.png" class="itemIcon" alt="">
        <span class="word">购物车</span>
      </div>
      <div class="line"></div>
      <div class="item" @click="openCustomer">
        <img src="/images/common/service.png" class="itemIcon" alt="">
        <span class="word">客服</span>
      </div>
      <div class="line"></div>
      <div class="item" @mouseenter.stop="show = true" @mouseleave.stop="show = false">
        <img src="/images/common/miniCode.png" class="itemIcon" alt="">
        <span class="word">小程序</span>
        <div class="box" v-if="show">
          <img src="/images/xcx_icon.png" class="img" alt="">
        </div>
      </div>
      <div class="line"></div>
      <div class="item" @click="scrollToTop">
        <img src="/images/common/backTop.png" class="itemIcon" alt="">
        <span class="word">TOP</span>
      </div>
    </div>
    <div>
      <el-dialog title="业务客服人员" :visible.sync="dialogVisible" width="30%">
        <div class="center">
          <div class="word">丁经理：15038649914</div>
          <div class="word">赵经理：15896605167</div>
          <div class="word">刘经理：13838895596</div>
          <div class="word">张经理：15290592053</div>
          <div class="word">晁经理：18437959307</div>

        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navbar',
  data() {
    return {
      dialogVisible: false,
      show: false
    }
  },
  methods: {
    // 客服
    openCustomer() {
      window.open('https://webchat-sh.clink.cn/chat.html?accessId=6af59333-c61e-4a5d-af37-40a48443d75d&language=zh_CN')
    },
    jumpCart() {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (this.$route.name == 'guide') {
        return
      }
      this.$router.push('/cart');
    },
    scrollToTop() {
      // 尝试多种滚动方式
      const scrollContainer = document.querySelector('.home') ||
        document.scrollingElement ||
        document.documentElement;

      if (scrollContainer) {
        // 平滑滚动到顶部
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }

      // 兼容方案：同时调用 window.scrollTo
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style lang='scss' scoped>
.navbar {
  width: 56px;
  background-color: #fff;
  border-radius: 12px 0px 0px 12px;
  border: 1px solid #EBEBEB;
  position: fixed;
  bottom: 160px;
  right: 0;
  z-index: 20;
  cursor: pointer;

  .item {
    width: 56px;
    height: 54px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .itemIcon {
      width: 20px;
    }

    .word {
      font-size: 12px;
    }

    .box {
      width: 200px;
      height: 200px;
      background-color: #fff;
      box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -100px;
      right: 64px;

      .img {
        width: 180px;
        height: 180px;
        display: block;
      }
    }
  }

  .item:last-child {
    border-bottom: none;
  }
}

.center {
  width: 100%;

  .word {
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
  }
}
</style>